/* global System */
// register component(s) with react habitat

export default { Lieferoptionen: () => System.import('./index') }
